export default "__VITE_ASSET__BQtWMVF4__"